module.exports = __webpack_public_path__ + "static/img/rank_42.4f9e574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_42.png
// module id = OK6B
// module chunks = 0